import { apiRequest } from './client';
import type {
  LoyverseConnectionResponse,
  LoyverseEmployeesResponse,
  LoyverseItemsResponse,
  LoyverseReceiptSyncInput,
  LoyverseReceiptSyncResponse,
  LoyverseReceiptSyncStatusResponse,
  LoyverseStoresResponse,
  LoyverseSyncResponse,
  LoyverseSyncRunListResponse,
  LoyverseSyncSettingsResponse,
  LoyverseSyncStatusResponse,
  SaveLoyverseConnectionInput,
  UpdateLoyverseSyncSettingsInput,
} from '../types/loyverse';

const LOYVERSE_PATH = '/api/integrations/loyverse';

export function getLoyverseConnection(): Promise<LoyverseConnectionResponse> {
  return apiRequest<LoyverseConnectionResponse>(LOYVERSE_PATH);
}

/** ZTV-04: presencia de la integración (solo booleano); disponible para cualquier rol del negocio. */
export function getLoyversePresence(): Promise<{ connected: boolean }> {
  return apiRequest<{ connected: boolean }>(`${LOYVERSE_PATH}/presence`);
}

export function saveLoyverseConnection(
  input: SaveLoyverseConnectionInput,
): Promise<LoyverseConnectionResponse> {
  return apiRequest<LoyverseConnectionResponse>(LOYVERSE_PATH, {
    method: 'PUT',
    body: JSON.stringify(input),
  });
}

export function testLoyverseConnection(): Promise<LoyverseConnectionResponse> {
  return apiRequest<LoyverseConnectionResponse>(`${LOYVERSE_PATH}/test`, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

export function deactivateLoyverseConnection(): Promise<LoyverseConnectionResponse> {
  return apiRequest<LoyverseConnectionResponse>(LOYVERSE_PATH, {
    method: 'DELETE',
  });
}

export function syncLoyverseCatalog(): Promise<LoyverseSyncResponse> {
  return syncRequest('catalog');
}

export function syncLoyverseStores(): Promise<LoyverseSyncResponse> {
  return syncRequest('stores');
}

export function syncLoyverseEmployees(): Promise<LoyverseSyncResponse> {
  return syncRequest('employees');
}

export function syncLoyverseItems(): Promise<LoyverseSyncResponse> {
  return syncRequest('items');
}

export function getLoyverseSyncStatus(): Promise<LoyverseSyncStatusResponse> {
  return apiRequest<LoyverseSyncStatusResponse>(`${LOYVERSE_PATH}/sync/status`);
}

export function getLoyverseCatalogStores(): Promise<LoyverseStoresResponse> {
  return apiRequest<LoyverseStoresResponse>(`${LOYVERSE_PATH}/catalog/stores`);
}

export function getLoyverseCatalogEmployees(): Promise<LoyverseEmployeesResponse> {
  return apiRequest<LoyverseEmployeesResponse>(`${LOYVERSE_PATH}/catalog/employees`);
}

export function getLoyverseCatalogItems(): Promise<LoyverseItemsResponse> {
  return apiRequest<LoyverseItemsResponse>(`${LOYVERSE_PATH}/catalog/items`);
}

export function syncLoyverseReceipts(
  input: LoyverseReceiptSyncInput,
): Promise<LoyverseReceiptSyncResponse> {
  return apiRequest<LoyverseReceiptSyncResponse>(
    `${LOYVERSE_PATH}/sync/receipts`,
    {
      method: 'POST',
      body: JSON.stringify(input),
    },
  );
}

export function getLoyverseReceiptSyncStatus(): Promise<LoyverseReceiptSyncStatusResponse> {
  return apiRequest<LoyverseReceiptSyncStatusResponse>(
    `${LOYVERSE_PATH}/sync/receipts/status`,
  );
}

// Fase 21B: historial de corridas de sync.
export function getLoyverseSyncRuns(limit = 25, offset = 0): Promise<LoyverseSyncRunListResponse> {
  return apiRequest<LoyverseSyncRunListResponse>(
    `${LOYVERSE_PATH}/sync-runs?limit=${limit}&offset=${offset}`,
  );
}

// Fase 21B: activar/desactivar auto-sync e intervalo.
export function updateLoyverseSyncSettings(
  input: UpdateLoyverseSyncSettingsInput,
): Promise<LoyverseSyncSettingsResponse> {
  return apiRequest<LoyverseSyncSettingsResponse>(`${LOYVERSE_PATH}/sync-settings`, {
    method: 'PATCH',
    body: JSON.stringify(input),
  });
}

function syncRequest(entity: string): Promise<LoyverseSyncResponse> {
  return apiRequest<LoyverseSyncResponse>(`${LOYVERSE_PATH}/sync/${entity}`, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}
